export const AUTH_HEADER = "Authorization";
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = "access-token";
export const LOCAL_STORAGE_STRAPI_URL_KEY = "strapi-url";
